import { AnalyticsEvent, AddToCartAnalyticsEvent } from '@/entities/analytics/AnalyticsEvents';
import { ShoppingCartItemAnalytics } from '@/entities/analytics/ShoppingCartItemAnalytics';

function ensureDataLayer(): Window & typeof globalThis & { dataLayer: AnalyticsEvent[] } {
    (window as any).dataLayer = (window as any).dataLayer || [];
    return window as Window & typeof globalThis & { dataLayer: AnalyticsEvent[] };
}

export function trackAddItemsToShoppingCart(items: ShoppingCartItemAnalytics[]): void {
    if (items == null || items.length === 0) {
        return;
    }

    const event: AddToCartAnalyticsEvent = {
        event: 'addToCart',
        ecommerce: {
            currencyCode: items[0].currencyCode,
            add: {
                products: items.map((item) => ({
                    name: item.name,
                    id: item.id,
                    price: item.price,
                    brand: item.brand,
                    category: item.categories,
                    quantity: item.quantity,
                    currencyCode: item.currencyCode,
                })),
            },
        },
    };
    ensureDataLayer().dataLayer.push(event);
}
